import axiosInstance from '@/services/axiosInstance';
import { GenericErrorResponseError } from '@brainvaulttech/dgr-react-sdk';
import { useInfiniteQuery } from '@tanstack/react-query';
import type { ChangeLogResponse, ChangeLogTarget } from '@/types/changeLog.types';

export const CHANGE_LOG_PAGE_SIZE = 20;

// Change log of a vendor or work order, newest first (ZOHO-1480). Only fetched while
// its tab is open, and always refetched when the tab is reopened so a new save shows up.
export const useGetChangeLog = (target: ChangeLogTarget, enabled: boolean) => {
  const serviceType = target.recordType === 'WORK_ORDER' ? target.serviceType : undefined;

  return useInfiniteQuery<ChangeLogResponse, GenericErrorResponseError>({
    queryKey: ['changeLog', target.recordType, serviceType, target.recordId],
    queryFn: async ({ pageParam }) => {
      const response = await axiosInstance.get<ChangeLogResponse>('/change-logs', {
        params: {
          recordType: target.recordType,
          serviceType,
          recordId: target.recordId,
          page: pageParam,
          pageSize: CHANGE_LOG_PAGE_SIZE,
        },
      });
      return response.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      const loaded = pages.reduce((total, page) => total + page.changeLogs.length, 0);
      return loaded < lastPage.totalRows ? pages.length + 1 : undefined;
    },
    enabled: enabled && !!target.recordId,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
